import { EControlsType, EControls } from '../../enums/controls.enum';

export const ControlsConfig: { [key: string]: { [key: string]: any } } = {
  [EControls.clientBirthDate]: {
    id: EControls.clientBirthDate,
    label: 'birthdate',
    order: 2,
    preventFutureDates: true,
    required: true,
    type: EControlsType.DATE
  },
  [EControls.clientBirthPlace]: {
    class: 'personal',
    entity: 'city',
    id: EControls.clientBirthPlace,
    label: 'birthplace',
    order: 6,
    type: EControlsType.AUTOSUGGEST,
    criteria: ''
  },
  [EControls.clientCity]: {
    class: 'residence',
    entity: 'city',
    id: EControls.clientCity,
    label: 'city',
    order: 15,
    type: EControlsType.AUTOSUGGEST,
    criteria: EControls.clientProvince
  },
  [EControls.clientCountry]: {
    class: 'residence',
    id: EControls.clientCountry,
    label: 'country',
    order: 13,
    service: 'countries',
    type: EControlsType.SELECT
  },
  [EControls.clientCountryName]: {
    id: EControls.clientCountryName,
    label: '',
    required: true,
    type: EControlsType.TEXT
  },
  [EControls.clientEmail]: {
    class: 'personal',
    id: EControls.clientEmail,
    label: 'email',
    order: 2,
    type: EControlsType.TEXT,
    trimValue: true
  },
  [EControls.clientFirstSurname]: {
    class: 'personal',
    id: EControls.clientFirstSurname,
    label: 'first-lastname',
    order: 3,
    type: EControlsType.TEXT
  },
  [EControls.clientGender]: {
    class: 'personal',
    id: EControls.clientGender,
    label: 'gender',
    order: 7,
    service: 'gender',
    type: EControlsType.SELECT
  },
  [EControls.clientIdIssuedAt]: {
    class: 'residence',
    entity: 'city',
    id: EControls.clientIdIssuedAt,
    label: 'issued-in',
    order: 11,
    type: EControlsType.AUTOSUGGEST,
    criteria: ''
  },
  [EControls.clientIdIssuedOn]: {
    class: 'residence',
    id: EControls.clientIdIssuedOn,
    label: 'issued-date',
    order: 12,
    type: EControlsType.DATE
  },
  [EControls.clientIdValidityDate]: {
    class: 'residence',
    id: EControls.clientIdValidityDate,
    label: 'id-valid-date',
    order: 12,
    type: EControlsType.DATE,
    allowFutureYears: true
  },
  [EControls.clientIdNumber]: {
    class: 'residence',
    id: EControls.clientIdNumber,
    label: 'document-id',
    order: 10,
    type: EControlsType.TEXT,
    uppercase: true
  },
  [EControls.clientIdType]: {
    class: 'residence',
    id: EControls.clientIdType,
    label: 'document-type',
    options: [],
    order: 9,
    type: EControlsType.SELECT
  },
  [EControls.clientName]: {
    class: 'personal',
    id: EControls.clientName,
    label: 'name',
    order: 1,
    type: EControlsType.TEXT
  },
  [EControls.clientNationality]: {
    id: EControls.clientNationality,
    label: 'nationality',
    order: 1,
    required: true,
    service: 'countries',
    type: EControlsType.SELECT
  },
  [EControls.clientNationalityName]: {
    id: EControls.clientNationalityName,
    label: '',
    required: true,
    type: EControlsType.TEXT
  },
  [EControls.clientPhoneNumber]: {
    class: 'personal',
    id: EControls.clientPhoneNumber,
    label: 'phone',
    order: 5,
    type: EControlsType.PHONE
  },
  [EControls.clientPostalCode]: {
    class: 'residence',
    id: EControls.clientPostalCode,
    label: 'postal-code',
    order: 17,
    type: EControlsType.TEXT
  },
  [EControls.clientSupportNumber]: {
    class: 'residence',
    id: EControls.clientSupportNumber,
    label: 'support-number',
    order: 19,
    type: EControlsType.TEXT,
    uppercase: true
  },
  [EControls.clientKinship]: {
    class: 'kinship',
    id: EControls.clientKinship,
    label: 'kinship',
    order: 20,
    service: 'kinship',
    type: EControlsType.SELECT,
  },
  [EControls.clientProvince]: {
    class: 'residence',
    entity: 'province',
    id: EControls.clientProvince,
    label: 'province',
    order: 14,
    type: EControlsType.AUTOSUGGEST,
    criteria: EControls.clientCountry
  },
  [EControls.clientRegion]: {
    class: 'residence',
    entity: 'region',
    id: EControls.clientRegion,
    label: 'region',
    order: 14,
    type: EControlsType.TEXT
  },
  [EControls.clientSecondSurname]: {
    class: 'personal',
    id: EControls.clientSecondSurname,
    label: 'second-lastname',
    order: 4,
    type: EControlsType.TEXT
  },
  [EControls.clientStreet]: {
    class: 'residence',
    id: EControls.clientStreet,
    label: 'address',
    order: 16,
    type: EControlsType.TEXT
  },
  [EControls.clientTaxId]: {
    class: 'residence',
    id: EControls.clientTaxId,
    label: 'tax-id',
    order: 18,
    type: EControlsType.TEXT
  },
  [EControls.typeOfGuest]: {
    class: 'personal',
    id: EControls.typeOfGuest,
    label: 'type-of-guest',
    order: 8,
    service: 'typeOfGuest',
    type: EControlsType.SELECT
  },
  [EControls.acceptCommercialInfo]: {
    id: EControls.acceptCommercialInfo,
    label: 'prevent-commercial-information',
    type: EControlsType.CHECK,
    value: false
  },
  [EControls.confirmFields]: {
    id: EControls.confirmFields,
    // The label will have to be passed because it depends on external parameters
    required: true,
    type: EControlsType.CHECK
  }
};
